<template>
  <div>
    <PageAllow
      controller="Shops"
      :action="settings && settings.specified_balance_consumption ? 'getShopBalanceHistories' : 'false'"
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t(isNew ? "CRUD.new" : "CRUD.edit") }}{{ $t("specifiedBalance.title") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $permission.checkAccountExpired().then(() => {
                    $router.replace('/capital');
                  })
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("capital.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
<!--        title下备注-->
<!--        <v-row align="center" class="ma-0 bgGreen" style="height: 45px">-->
<!--          <span class="mx-7 subtitle-2 font-weight-bold">-->
<!--            {{ $t("MaterialOrderRule.autoStandardRule.hint") }}-->
<!--          </span>-->
<!--        </v-row>-->
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("specifiedBalance.type") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group
                  row
                  v-model="specified_balance_type"
                  persistent-hint
                  v-if="savable"
                >
                  <v-radio
                    :label="$t('specifiedBalance.Fields.categories')"
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="$t('specifiedBalance.Fields.materials')"
                    :key="2"
                    :value="2"
                  />
                </v-radio-group>
                <span v-else>
                  {{ (specified_balance_type == 1) ? $t('specifiedBalance.Fields.categories') : $t('specifiedBalance.Fields.materials') }}
                </span>
              </v-col>
            </v-row>
            <v-row v-if="specified_balance_type == 1">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("MaterialOrderRule.expressFee.choosed_Category") + $t("Global.colon") }}
                <br />
                <v-btn
                  v-if="savable"
                  color="primary"
                  class="my-1 mr-3"
                  x-small
                  outlined
                  @click.stop="
                    category_dialog = true;
                    currentCategories = categories;
                  "
                >
                  {{ $t("MaterialOrderRule.Fields.category_express") }}
                </v-btn>
              </v-col>
              <v-col cols="9" md="7">
                <span
                    class="my-1 mr-3 mt-4"
                    v-for="(detail, index) in categories"
                    :key="index"
                    :style="savable ? 'font-size: 16px' : 'font-size: 14px'"
                >{{ detail.name }}
                </span>
              </v-col>
            </v-row>
            <v-row v-if="specified_balance_type == 2">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("specifiedBalance.Fields.materials") + $t("Global.colon") }}
                <br />
                <v-btn
                  v-if="savable"
                  color="primary"
                  class="my-1 mr-3"
                  x-small
                  outlined
                  @click="materials_dialog = true"
                >
                  {{ $t("CRUD.chooseInfo", [$t("MaterialOrderRule.Fields.material")]) }}
                </v-btn>
              </v-col>
              <v-col cols="9" md="7">
                <v-data-table
                    :headers="materialHeaders"
                    :items="materialItems"
                    :loading="materialsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                >
                  <template v-slot:header.actions="{ header }">
                    {{ header.text }}
                    <v-icon x-small>fa-sliders-h</v-icon>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materials.splice(
                            materials.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                    >
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $permission.checkAccountExpired().then(() => {
                      $router.replace('/capital');
                    })
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{
                    $t("CRUD.backToList", [$t("capital.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&
                  settings && settings.specified_balance_consumption
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading"
                  @click="toEdit = true"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.edit") }}{{ $t("specifiedBalance.title") }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  settings && settings.specified_balance_consumption
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}{{ $t("specifiedBalance.title") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
      <MaterialsSelectsDialog
        v-model="materials_dialog"
        @confirm="materials = $event"
        :material-ids="materialIds"
      />
      <DialogCategories
        v-model="category_dialog"
        :categorySelected="currentCategories"
        @confirm="addCategories($event)"
        isNotDisabled
      />
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import MaterialsSelectsDialog from "./plugins/MaterialsSelectsDialog";
import BalanceSpecifieds from "@/api/balance_specifieds"
import DialogCategories from "@/components/plugins/DialogCategories";

export default {
  components: {
    DialogCategories,
    PageAllow,
    Breadcrumbs,
    MaterialsSelectsDialog,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.capital"),
        disabled: false,
        href: "/capital",
      },
      {
        text: i18n.t("capital.specifiedBalance"),
        disabled: true,
        href: "/capital",
      },
    ],
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isView() {
      return this.mode == "view";
    },
    ruleType() {
      return this.$route.query.type;
    },

    materialHeaders() {
      var materialHeaders = [];
      materialHeaders.push({
        text: i18n.t("MaterialOrderRule.Fields.category_name"),
        align: "start",
        sortable: false,
        value: "material_category.name",
      });

      materialHeaders.push({
        text: i18n.t("MaterialOrderRule.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "Description",
      });
      if (this.savable) {
        materialHeaders.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      return materialHeaders;
    },

    materialItems() {
      return this.materials.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    mode: "",
    serverErrors: [],
    materials_dialog: false,
    materials: [],
    materialIds: [],
    materialsLoading: false,
    toEdit: false,
    category_dialog: false,
    categories: [],
    currentCategories: [],
    categoriesSelected: [],
    specified_balance_type: 1,
  }),

  mounted() {
    this.mode = this.$route.query.mode ? this.$route.query.mode : "view";
    this.getOrderRuleFromAPI();
  },

  methods: {
    getOrderRuleFromAPI() {
      this.$store.dispatch("fullscreenLoading");
      BalanceSpecifieds.fetch().then(
        function (response) {
          if (response.data.status.isOK()) {
            if (
                response.data.specified_type == null ||
                response.data.specified_type == "undefined" ||
                response.data.specified_type == undefined
            ) {
              this.specified_balance_type = 1;
            }else {
              this.specified_balance_type = response.data.specified_type;
            }
            this.categories = response.data.categories.map((detail) => {
              return {
                name: detail.category_name,
                code: detail.category_code,
                id: detail.category_id,
              }
            });
            this.materials = response.data.materials.map((material) => {
              material.id = material.material_id;
              return material
            });
            this.materialIds = response.data.material_ids;
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this));
    },
    addCategories(data) {
      this.categories = data;
      let codes = [];
      this.categories.forEach((detail) => {
        codes.push(detail.code);
      });
      this.categoriesSelected = codes;
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      let submit_data = {};
      submit_data.specified_balance_type = this.specified_balance_type
      if (this.specified_balance_type == 1) {
        submit_data.category_codes = this.categories.map((category) => {
          return category.code
        })
      } else if(this.specified_balance_type == 2) {
        submit_data.material_ids = this.materials.map((material) => {
          return material.id
        })
      }
      BalanceSpecifieds.save(submit_data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$store.dispatch("fullscreenLoadingStop");
            this.$snackbar.success(i18n.t("specifiedBalance.saveSuccess"));
            this.toEdit = false
            this.$router.replace("/capital/specified-balance/");
          }
          }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this));
    },
  },

  watch: {
    toEdit: {
      handler() {
        if (this.toEdit) {
          this.$router.replace({
            path: this.$route.path,
            query: { mode: "edit" },
          });
          this.mode = "edit";
        }else {
          this.$router.replace({
            path: this.$route.path
          });
          this.mode = "view";
        }
      },
    },
    specified_balance_type: {
      handler() {
        if (this.specified_balance_type == 1) {
          this.materials = [];
        } else {
          this.categories = [];
          this.currentCategories = [];
          this.categoriesSelected = [];
        }
      }
    },
    materials: {
      handler() {
        if (this.materials) {
          this.materialIds = this.materials.map((material) => {
            return material.id
          })
        }
      }
    }
  },
};
</script>